import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { InventoryPage } from '@/features/inventory/components/InventoryPage';

const searchSchema = z.object({
  columnFilters: z
    .array(
      z.object({
        id: z.string(),
        value: z.unknown(),
      })
    )
    .optional(),
});

export const Route = createFileRoute('/$commiteeSlug/inventory/')({
  component: InventoryPage,
  validateSearch: searchSchema,
});
